export default __webpack_public_path__ + "static/media/mendesarthur.0826879a.jpg";